import { useEffect, useState } from 'react';
import styles from './page.module.css';
import Card from "../../components/Card/Card";
import SportModul from "../../components/SportModul/SportModul";
import { fetchModulesByCategory } from '../../../code/SportModuleLoader';
import HeroBanner from '../../components/HeroBanner/HeroBanner';
import PersonCard from '../../components/PersonCard/PersonCard';
import { loadAssignmentsByArea } from '../../../code/AssignmentPersons';
function Gesundheitssport() {
    const [module, setModule] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasImages, setHasImages] = useState(false);
    const [personsAnsprechpartner, setPersonsAnsprechpartner] = useState([]);
    const color = '--color-blue';
    const colorText = "--main-color-white";
    useEffect(() => {
        loadAssignmentsByArea(15, setPersonsAnsprechpartner, color, colorText);
    }, []);

    useEffect(() => {
        setLoading(true);
        fetchModulesByCategory('firmenfitness', setModule);
        setLoading(false);
    }, []);

    if (loading) {
        return (<div></div>)
    }
    return (
        <div>
            <HeroBanner category="firmenfitness" onImagesLoaded={setHasImages} />
            <section className={styles.container} style={{ marginTop: hasImages ? '20px' : 'var(--marginTopDefault)' }}>
                <h1>Firmenfitness</h1>
                <div className={styles.startText}>
                    <ul className={styles.firmenFitnessUl}><li>Gemeinsam in Bewegung: Sport fördert und verbindet</li></ul>
                    <p>Hast du schon mal darüber nachgedacht, Sport und Arbeit zu verbinden? Egal ob du Arbeitnehmer oder Arbeitgeber bist, beide Seiten profitieren davon, dass Firmenfitness angeboten bzw. angenommen wird. Wir möchten Sie / euch regional und nah sportlich aktivieren.</p>
                    <p>Wir können dein regionaler Partner für deine betriebliche Gesundheitsförderung werden. Wir möchten darin unterstützen, das passende Angebot zu schaffen und die Umsetzung aktiv zu begleiten. Hier bieten sich vielfältige Möglichkeiten, wie wir zusammenarbeiten können:</p>
                </div>

                {/* <section>
                    <div className={styles.modulesContainer} >
                        {module.map((modul, index) => (
                            <Card
                                key={index}
                                id={modul.anchor_id}
                                icon={`${process.env.PUBLIC_URL}${modul.iconPath || modul.icon_path}`}
                                iconText={modul.iconText}
                                title={modul.title}
                                rightText={modul.class || ''}
                            >
                                <SportModul modul={modul} />
                            </Card>
                        ))}
                    </div>
                </section> */}
                <div className={styles.options}>
                    <section className={styles.option}>
                        <h3>Betriebssportkurse</h3>
                        <p>Seit 2014 bietet der TuS 05 Oberpleis Betriebssport an. Mit dem <strong>1. TuS-Gesundheitstag</strong>, der 2025 gemeinsam mit der <a href="https://www.aok.de/pk/rh/" target="_blank" rel="noopener noreferrer">AOK Rheinland/Hamburg</a> durchgeführt wurde, gelang dem Verein ein weiterer wichtiger Schritt im Bereich der Betrieblichen Gesundheitsförderung.</p>

                        <p>Die Fitnessangebote des TuS beugen Büroleiden wie z.B. Rückenproblemen entgegen und stärken präventiv das Gesundheitsbewusstsein der Mitarbeiterinnen und Mitarbeiter! Due Belegschaft wird durch die regelmäßige Bewegung am Arbeitsplatz ausgegelichener und weniger gestresst. Die Sport- und Bewegungsangebote tragen außerdem zu einer attraktiven, motivierenden Unternehmenskultur bei.</p>
                    </section>
                    <section className={styles.option}>
                        <h3>Workshops - sportliche Firmenevents</h3>
                        <p><strong>                        Gemeinsame Vorbereitung auf z. B. Laufevents und Firmenläufe</strong></p>
                        <p>Egal ob Einsteiger oder Fortgeschrittene – bei uns steht das gemeinsame Training im Vordergrund. Zusammen bereiten wir uns gezielt auf verschiedene Laufevents und Firmenläufe vor, steigern die Fitness, verbessern die Lauftechnik und motivieren uns gegenseitig zu neuen Bestleistungen. Dabei kommt auch der Spaß an der Bewegung nicht zu kurz!</p>
                    </section>
                    <section className={styles.option}>
                        <h3>Gesundheitstage</h3>
                        <div className={styles.videoDiv}>
                            <video
                                className={styles.video}
                                src="/uploads/video/20250410_Gesundheitstag_Zera.mp4"
                                controls
                                controlsList="nofullscreen"
                                muted
                                autoPlay
                                loop
                            >
                                Your browser does not support the video tag.
                            </video>
                            <div>
                                <p><strong>Unser erster Gesundheitstag im Überblick</strong></p>
                                <p>
                                    Am 10. April 2025 fand unser erster Gesundheitstag statt – gemeinsam mit der Firma <a href="https://www.zera.de/" target="_blank" rel="noopener noreferrer">ZERA</a> und in Kooperation mit der <a href="https://www.aok.de/pk/rh/" target="_blank" rel="noopener noreferrer">AOK Rheinland/Hamburg</a>.
                                </p>
                                <p>
                                    Mehr dazu erfahrt ihr im folgenden Artikel: <a href={`${process.env.REACT_APP_BACKEND_URL}/uploads/files/Berichterstattung_Zeitungsartikel_Gesundheitstag_1_TuS05Oberpleis.pdf`} target="_blank" rel="noopener noreferrer">
                                        Zeitungsartikel als PDF
                                    </a>
                                </p>
                            </div>
                        </div>
                    </section>
                </div>
                <section>
                    <h2>Ansprechpartner</h2>
                    <div className={styles.ansprechpartnerText}>
                        <p><strong>Sie sind an einem individuellen Angebot für ihr Unternehmen interessiert?</strong></p>
                        <p>Dann melden Sie sich bei uns telefonisch <span>02244 - 90 20 117</span> oder über Michael oder Verena.</p>
                        <p>Wir freuen uns darauf, ihr Unternehmen noch fitter und attraktiver zu machen.</p>
                    </div>
                    <div className={styles.ansprechpartner}>
                        {personsAnsprechpartner.map((person) => (<PersonCard person={person}></PersonCard>))}
                    </div>
                </section>
            </section>
        </div>
    )
}

export default Gesundheitssport;